import { html } from '../lib/html.js';
import { icon } from '../lib/icons.js';

// One toast at a time; a new one replaces the old. Announced politely.
let current = null;

export function toast(message, { action, onAction, timeout = 4200 } = {}) {
  const host = document.getElementById('toasts');
  if (!host) return;
  if (current) current.remove();
  const el = document.createElement('div');
  el.className = 'toast';
  el.innerHTML = String(html`
    <span class="toast__msg">${message}</span>
    ${action ? html`<button type="button" class="toast__action">${action}</button>` : ''}
    <button type="button" class="icon-btn toast__close" aria-label="Dismiss">${icon('close', { size: 18 })}</button>`);
  host.appendChild(el);
  current = el;
  let timer = null;
  const close = () => {
    clearTimeout(timer);
    if (!el.isConnected) return;
    el.classList.add('toast--leaving');
    setTimeout(() => el.remove(), 220);
    if (current === el) current = null;
  };
  el.querySelector('.toast__close').addEventListener('click', close);
  if (action) {
    el.querySelector('.toast__action').addEventListener('click', () => {
      close();
      if (onAction) onAction();
    });
  }
  if (timeout) timer = setTimeout(close, timeout);
  el.addEventListener('pointerenter', () => clearTimeout(timer));
  el.addEventListener('pointerleave', () => {
    if (timeout) timer = setTimeout(close, 2000);
  });
  return close;
}
